(() => {
  if (customElements.get('pm-home-before-after-slider')) return;

  class PmHomeBeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;

      this._range = this.querySelector('[data-pm-home-before-after-range]');
      if (!this._range) return;

      this._gesture = null;
      this._handleInput = () => {
        // A vertical page swipe can make a native range briefly update before
        // the browser resolves pan intent. Keep the authored value untouched
        // unless the gesture has positively resolved as horizontal.
        if (this._gesture && this._gesture.intent !== 'horizontal') {
          this._range.value = this._gesture.startValue;
        }
        this.syncFromRange();
      };
      this._handlePointerDown = (event) => {
        if (!event.isPrimary || event.pointerType === 'mouse') return;
        this._gesture = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startValue: this._range.value,
          intent: 'pending'
        };
      };
      this._handlePointerMove = (event) => {
        const gesture = this._gesture;
        if (!gesture || event.pointerId !== gesture.id || gesture.intent !== 'pending') return;
        const dx = Math.abs(event.clientX - gesture.startX);
        const dy = Math.abs(event.clientY - gesture.startY);
        if (Math.max(dx, dy) < 6) return;
        gesture.intent = dy >= 1.7 * dx ? 'vertical' : 'horizontal';
        if (gesture.intent === 'vertical') {
          this._range.value = gesture.startValue;
          this.syncFromRange();
        }
      };
      this._handlePointerEnd = (event) => {
        const gesture = this._gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        if (gesture.intent !== 'horizontal') {
          this._range.value = gesture.startValue;
          this.syncFromRange();
        }
        this._gesture = null;
      };
      this._handlePointerCancel = (event) => {
        const gesture = this._gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this._range.value = gesture.startValue;
        this.syncFromRange();
        this._gesture = null;
      };
      this._range.addEventListener('input', this._handleInput);
      this._range.addEventListener('pointerdown', this._handlePointerDown, { passive: true });
      this._range.addEventListener('pointermove', this._handlePointerMove, { passive: true });
      this._range.addEventListener('pointerup', this._handlePointerEnd, { passive: true });
      this._range.addEventListener('pointercancel', this._handlePointerCancel, { passive: true });
      this._connected = true;
      this.dataset.pmReady = 'true';
      this.syncInitialPosition();
    }

    disconnectedCallback() {
      this._range?.removeEventListener('input', this._handleInput);
      this._range?.removeEventListener('pointerdown', this._handlePointerDown);
      this._range?.removeEventListener('pointermove', this._handlePointerMove);
      this._range?.removeEventListener('pointerup', this._handlePointerEnd);
      this._range?.removeEventListener('pointercancel', this._handlePointerCancel);
      this._handleInput = null;
      this._handlePointerDown = null;
      this._handlePointerMove = null;
      this._handlePointerEnd = null;
      this._handlePointerCancel = null;
      this._gesture = null;
      this._range = null;
      this._connected = false;
      this.dataset.pmReady = 'false';
    }

    syncFromRange() {
      if (!this._range) return;
      const numericValue = Number.parseFloat(this._range.value);
      const value = Number.isFinite(numericValue)
        ? Math.min(100, Math.max(0, numericValue))
        : Number.parseFloat(this.dataset.initialPosition || '65.866');
      this.style.setProperty('--pm-home-before-after-position', `${value}%`);
      this.dataset.position = String(value);
      this._range.setAttribute('aria-valuetext', `${value}% before photo shown`);
    }

    syncInitialPosition() {
      if (!this._range) return;
      const numericValue = Number.parseFloat(this.dataset.initialPosition || '65.866');
      const value = Number.isFinite(numericValue)
        ? Math.min(100, Math.max(0, numericValue))
        : 65.866;

      this._range.value = value.toFixed(3);
      this.style.setProperty('--pm-home-before-after-position', `${value}%`);
      this.dataset.position = String(value);
      this._range.setAttribute('aria-valuetext', `${value}% before photo shown`);
    }
  }

  customElements.define('pm-home-before-after-slider', PmHomeBeforeAfterSlider);
})();
